module.exports = __webpack_public_path__ + "static/media/4ODA6.a2dc89ea.jpg";